<template>
  <div class="wrapper">
  <div class="fond">
    <div class="bg-left"></div>
    <div class="bg-right"></div>
  </div>
  <div class="contenair">
    <img class="logo" src="/logo.svg">
    <div class="formulaire">
      <div class="form-left">
        <h1>Exemple de<br />formulaire</h1>
        <p>Catalogue des champs<br />disponibles</p>
      </div>
      <div class="form-right">
         <div class="form">
         <div class="etape">&Eacute;tape {{ step+1 }}/3 :</div> 
         <Form :class="'form_step'+step"
            id="myform"
            :form_id="form_id"
            :server="server"
            v-on:results="getResult"
            v-on:step-up="checkStep"
            v-on:step-down="checkStep"
            v-on:form_submit_loading=loading
          />
          <br /><br />
         </div>
      </div>     
    </div>
  </div>
  </div>
</template>
<script>
var consts = require('../config');
import axios from "axios";

export default {
  name: "form",
  data: function () {
    return {
      step: 0,
      form_id: consts.FORM_ID,
      server: consts.SERVER_URL,
    };
  },
  methods: {
    loading(value) {
      if (value === true) {
        this.$swal({
          allowOutsideClick: false,
          title: 'Envoi en cours',
          html: 'Merci de bien vouloir patienter ...',
          timerProgressBar: true,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
      }
    },
    checkStep(checkStep) {
       this.step = checkStep++
    },
    getResult(result) {
      if (result._id) {
        this.$swal.close()
        this.$router.push("/done");
      } else {
        alert('Erreur interne')
      }
    },
  },
  mounted() {
  },
  created: function () {}
} 
</script>